/** @module Enums */ /** typedoc */

/**
 * Style used to master.
 */
export enum MasteringStyleEnum {
    Warm = 'PS1',
    Balanced = 'PS2',
    Open = 'PS3',
}
